import Label, { LabelGroup } from 'common/components/Label'
import React, { forwardRef } from 'react'
import styled from 'react-emotion'
import { useTranslation } from 'react-i18next'
import { z } from '../../style'
import ActivityIcon from '../Activity/ActivityIcon'
// import CreateBoardButton from '../common/CreateBoardButton'
import Button from 'common/components/Button'
import Icon from 'common/components/Icon'
import Row from 'common/components/Row'

const Toolbar = styled(
  forwardRef(({ solid, allowed, ...props }, ref) => {
    return <Row {...props} innerRef={ref} />
  })
)(({ solid = false }) => ({
  label: 'Toolbar',
  zIndex: z.toolbar,

  position: 'absolute',
  width: '100%',
  top: 0,

  pointerEvents: !solid && 'none',
  '& > *': !solid && { pointerEvents: 'all' }
}))

export default ({
  children,
  sidebarShowing,
  toggleSidebar,
  empty,
  embed,
  Shortcuts,
  currentMode,
  setMode,
  toggleMode,
  ...props
}) => {
  const { t } = useTranslation()
  if (embed) return null
  return (
    <>
      <Toolbar {...props}>
        {!empty && !sidebarShowing && (
          <LabelGroup>
            {/* <CreateBoardButton /> */}
            <Button
              tooltip={t('sidebar.tooltips.openSidebar')}
              onClick={toggleSidebar}
            >
              <Icon icon="menu" />
            </Button>

            <ActivityIcon />
          </LabelGroup>
        )}
        {children}
      </Toolbar>
      <Shortcuts />
    </>
  )
}

export const Loading = ({ type }) => (
  <Row>
    <Label>
      <Icon icon={type === 'board' ? 'loader' : 'loader-square'} />
    </Label>
  </Row>
)
